type Params = {
  error: string | Error | ErrorEvent
  level?: 'info' | 'debug' | 'warn' | 'error' | 'critical' | 'trace'
  additional?: Record<string, unknown>
  type?: string
  block?: string
  message?: string
}

export function logError({error, level, additional, type, block, message}: Params) {
  try {
    Ya.Rum.logError({level, additional, type, block, message}, error)
  } catch (error) {
    console.error(error)
  }
}
